import type { MaybeRefOrGetter } from 'vue'

import type { Config } from '../@types/editor'

type DeletablePlaysStore = {
  canDeleteAllPlays: (config: Config) => boolean
  deleteAllPlays: (config: Config) => void
}

export const useDeleteAllPlays = (
  store: DeletablePlaysStore,
  configRef: MaybeRefOrGetter<Config | null>,
) => {
  const { scrollTop } = useScrollUtils()

  const animated = ref(true)

  const config = computed(() => toValue(configRef))

  const canDeleteAllPlays = computed(() => !!config.value && store.canDeleteAllPlays(config.value))

  const deleteAllPlays = async () => {
    if (!config.value) return

    animated.value = false

    store.deleteAllPlays(config.value)

    await nextTick()
    animated.value = true

    scrollTop(0, 'instant')
  }

  return { animated, canDeleteAllPlays, deleteAllPlays }
}
